import { Box, Grid } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import { LoginContinueButton } from 'components/atoms/ButtonsOld';
import { useSignInProcess } from 'hooks/useSignInProcess';
import { useLoginFlow } from 'hooks/useLoginFlow';
import { useAuth } from 'context/authentication';
import GoogleIcon from '@mui/icons-material/Google';
import { db } from 'config/firebase';
import { useDispatch } from 'react-redux';
import { updateUsersLoginInfo } from 'redux/actions/internal/general/users';
import useTranslation from 'next-translate/useTranslation';
import { useExecutor } from 'hooks/useExecutor';
import { useLoginContext } from 'context/login-context';
import { useState } from 'react';
import { SmallText } from 'components/atoms/Typography';

interface ILoginContinueOptionsProps {
    onLogin?: (user?: any) => void;
}

const LoginContinueOptions = ({ onLogin }: ILoginContinueOptionsProps) => {
    const signInProcess = useSignInProcess();
    const { signInWithGoogle, signInWithFacebook, loginWithCredential, persistCredential, postUserToken } = useAuth();
    const dispatch = useDispatch();
    const authentication = useLoginFlow();
    const { t } = useTranslation('common');
    const checkEmailExecutor = useExecutor('/customers/checkEmailProviders');
    const { update } = useLoginContext();
    const [socialError, setSocialError] = useState<string>('');

    // useEffect(() => {
    //     if (authentication.isLoginOpen && !authentication.isRegisterOpen) {
    //         FirebaseUIManager.startUI('#firebaseui-login-container');
    //     }
    // }, [authentication.isLoginOpen]);

    const continueWithEmail = () => {
        signInProcess.nextStep('LOGIN_WITH_EMAIL');
    };

    const continueWithFacebook = () => {
        setSocialError('');
        signInWithFacebook()
            .then(res => {
                db.doc(`/customers/${res.user.uid}`)
                    .get()
                    .then(data => {
                        if (data.exists) {
                            loginWithCredential(res.credential).then(userCredential => {
                                postUserToken(userCredential.user);
                                authentication.closeLogin();
                                onLogin?.(userCredential.user);
                            });
                        } else {
                            dispatch(
                                updateUsersLoginInfo({
                                    email: res.additionalUserInfo.profile?.['email'],
                                    name: (res.additionalUserInfo.profile as any).first_name,
                                    lastName: (res.additionalUserInfo.profile as any).last_name,
                                })
                            );
                            persistCredential(res.credential);
                            signInProcess.goThrough(['SOCIAL_GOOGLE'], 'REGISTER_INFO');
                            authentication.showRegister();
                        }
                    });
            })
            .catch(err => {
                console.log('error while sign in with Facebook', err);
                if (err.code === 'auth/account-exists-with-different-credential') {
                    if (err.email) {
                        checkEmailExecutor
                            .post({
                                email: err.email,
                            })
                            .then(res => {
                                if (res.success) {
                                    const _providers = res.data;
                                    dispatch(
                                        updateUsersLoginInfo({
                                            email: err.email,
                                        })
                                    );
                                    update('userProviders', _providers);
                                    signInProcess.nextStep('RECOGNIZED');
                                }
                            });
                    } else {
                        setSocialError(err.message || 'Error with connecting to facebook.');
                    }
                } else {
                    // setSocialError(err.message || 'Error with connecting to facebook.');
                }
            });
    };

    const continueWithGoogle = () => {
        setSocialError('');
        signInWithGoogle().then(res => {
            // if ((res.additionalUserInfo.profile as any)?.email) {
            //     const email = (res.additionalUserInfo.profile as any)?.email;

            //     checkEmailExecutor
            //         .post({
            //             email,
            //         })
            //         .then(resp => {
            //             if (resp.success) {
            //                 const _providers = resp.data;
            //                 if (_providers.length > 0) {
            //                     if (_providers.includes('google.com')) {
            //                         loginWithCredential(res.credential).then(userCredential => {
            //                             postUserToken(userCredential.user);
            //                             authentication.closeLogin();
            //                             onLogin?.(userCredential.user);
            //                         });
            //                     } else {
            //                         linkGoogleProviderExecutor
            //                             .post({
            //                                 email,
            //                                 uid: res.user.uid,
            //                                 idToken: (res.credential as any).idToken,
            //                             })
            //                             .then(r => {
            //                                 if (r.success) {
            //                                     loginWithCredential(res.credential).then(userCredential => {
            //                                         postUserToken(userCredential.user);
            //                                         authentication.closeLogin();
            //                                         onLogin?.(userCredential.user);
            //                                     });
            //                                 }
            //                             });
            //                     }
            //                 }
            //             } else {
            //                 dispatch(
            //                     updateUsersLoginInfo({
            //                         email: res.user.email,
            //                         name: (res.additionalUserInfo.profile as any).given_name,
            //                         lastName: (res.additionalUserInfo.profile as any).family_name,
            //                     })
            //                 );
            //                 persistCredential(res.credential);
            //                 signInProcess.goThrough(['SOCIAL_GOOGLE'], 'REGISTER_INFO');
            //                 authentication.showRegister();
            //             }
            //         });
            // }

            db.doc(`/customers/${res.user.uid}`)
                .get()
                .then(data => {
                    if (data.exists) {
                        loginWithCredential(res.credential).then(userCredential => {
                            postUserToken(userCredential.user);
                            authentication.closeLogin();
                            onLogin?.(userCredential.user);
                        });
                    } else {
                        dispatch(
                            updateUsersLoginInfo({
                                email: res.user.email,
                                name: (res.additionalUserInfo.profile as any).given_name,
                                lastName: (res.additionalUserInfo.profile as any).family_name,
                            })
                        );
                        persistCredential(res.credential);
                        signInProcess.goThrough(['SOCIAL_GOOGLE'], 'REGISTER_INFO');
                        authentication.showRegister();
                    }
                });
        });
    };

    return (
        <Box mt={1} pt={3}>
            <Grid container direction="column" alignItems="center">
                {/* <Grid item style={{ width: '100%', padding: '0' }}>
                    <Grid container justifyContent="center">
                        <LoginContinueButton Icon={FacebookIcon} onClick={continueWithFacebook}>
                            {t('continueFacebook')}
                        </LoginContinueButton>
                    </Grid>
    </Grid> */}
                {/* <Grid item style={{ width: '100%', padding: '0', marginTop: '10px' }}>
                    <Grid container justifyContent="center">
                        <LoginContinueButton Icon={MailOutline} onClick={continueWithEmail}>
                            {t('continueEmail')}
                        </LoginContinueButton>
                    </Grid>
                </Grid> */}
                <Grid item style={{ width: '100%', padding: '0', marginTop: '10px' }}>
                    <Box display="flex" justifyContent="center">
                        <LoginContinueButton Icon={GoogleIcon} onClick={continueWithGoogle}>
                            {t('continueGoogle')}
                        </LoginContinueButton>
                    </Box>
                </Grid>
                {/* <div id="firebaseui-login-container"></div> */}
            </Grid>
            {socialError && (
                <Box>
                    <SmallText color="red">{socialError}</SmallText>
                </Box>
            )}
        </Box>
    );
};

export default LoginContinueOptions;
